import { HiverKbBifrost } from "./Bifrost";
import { API_METHODS } from "./Constant/Bifrost";
import { apiRoutes, Hiver_New_Auth_Base_Url } from "./Constant/ApiRoutes";

import { processUrl } from "./utils";


export const getRequest = (
  url,
  payload
) => {
  const isAvailableFeature = url === apiRoutes.availableFeatures;
    if (!isAvailableFeature) url = processUrl(url);
    return HiverKbBifrost({
      url,
      method: API_METHODS.GET,
      params: payload,
      root_url: Hiver_New_Auth_Base_Url
  });
};

export const postRequest = (url, payload, params) => {
    /*
      params key in bifrost is not working as intended in converting the object
      to append in url as queryparam for POST so we are doing it manually here.
      We have to get a proper fix from admirals.This is quick fix for now.
    */
    url = processUrl(url);
    const searchParams = new URL(Hiver_New_Auth_Base_Url + url);
    params && Object.keys(params).forEach((key) => {
      searchParams.searchParams.append(key, params[key]);
    });
    url = searchParams?.search ? url + searchParams.search : url;

    return HiverKbBifrost({
      url,
      method: API_METHODS.POST,
      data: payload,
      root_url: Hiver_New_Auth_Base_Url
    });
};

export const putRequest = (url, payload, params) => {
  url = processUrl(url);
  return HiverKbBifrost({
    url,
    method: API_METHODS.PUT,
    data: payload,
    params,
    root_url: Hiver_New_Auth_Base_Url
  });
};

export const patchRequest = (url, payload, params) => {
  url = processUrl(url);
  return HiverKbBifrost({
    url,
    method: API_METHODS.PATCH,
    data: payload,
    params,
    root_url: Hiver_New_Auth_Base_Url
  });
};

export const deleteRequest = (url, bodyPayload, urlPayload) => {
  let config = {
    params: {
      ...urlPayload,
    },
    data: Array.isArray(bodyPayload) ? [...bodyPayload] : { ...bodyPayload },
  };
  url = processUrl(url);
  return HiverKbBifrost({
    url,
    method: API_METHODS.DELETE,
    data: config.data,
    params: config.params,
    root_url: Hiver_New_Auth_Base_Url,
  });
};
